import { OrdersApiService } from "../api/OrdersService";
import { CanceledOrderDetails } from "../models/order.interface";
import { IResult } from "../models/results/result.interface";
import logger from "../utils/logger";

const cancelOrder = async (
  id: string
): Promise<IResult<CanceledOrderDetails>> => {
  logger.info(cancelOrder.name, `Canceling order ${id}...`);
  try {
    const {
      response: resp,
      error,
    } = await OrdersApiService.ordersCancelSubjectOrder({
      id,
    });

    if (error || !resp) {
      logger.error(cancelOrder.name, "Invalid API response", {
        resp,
        error,
      });
      return {
        success: false,
        message: error?.errorMessage,
        errorCode: error?.errorCode?.toString(),
      };
    }

    const {
      orderNumber,
      studyName,
      subjectId,
      createdDetails,
      cancelledDetails: canceledDetails,
    } = resp;
    return {
      success: true,
      data: {
        orderNumber,
        studyName,
        subjectId,
        createdDetails,
        canceledDetails,
      },
    };
  } catch (error) {
    logger.error(cancelOrder.name, "Error canceling order.", error);
    return {
      success: false,
      message: (error as Error).message,
    };
  }
};

const ordersService = {
  cancelOrder,
};

export default ordersService;
